@use 'src/globals/main';

$container-border-width: 1em;
$container-border-space: 50%;

pn-file-upload {
  &.hover .pn-file-upload-container .pn-dropzone-container {
    background-color: main.$blue50;
  }

  .pn-file-upload-input {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    opacity: 0;
    height: 100%;
    width: 100%;
    -webkit-tap-highlight-color: transparent;
    &:hover {
      cursor: pointer;
      + .pn-dropzone-inner {
        border-color: main.$blue700;
        background-color: main.$blue50;
      }
    }
    &:focus-visible + .pn-dropzone-inner {
      border-color: main.$blue700;
      @include main.pn-focus-visible;
    }
    &:disabled {
      pointer-events: none;
      + .pn-dropzone-inner {
        pointer-events: none;
        background-color: main.$gray50;
        border-color: main.$gray900;
        .headline a {
          color: main.$gray700;
        }
        .pn-icon-svg path {
          fill: main.$gray700;
        }
      }
    }
  }

  .pn-file-upload-container {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 1em;
    .pn-dropzone-container {
      position: relative;
    }
    .pn-dropzone-inner {
      position: relative;
      text-align: center;
      overflow: hidden;

      padding: 2.5em;

      border: 0.0625em main.$gray400 dashed;
      border-radius: 0.5em;

      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5em;

      @include main.pn-focus-base;
      @include main.pn-transition('background-color, outline-color, border-color');
      @include main.pn-ripple(main.$blue700);

      &[data-hover] {
        background-color: main.$blue50;
        border-color: main.$blue700;
      }

      &[data-invalid] {
        border-color: main.$warning;
      }

      .pn-file-upload-dropzone {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 0.5em;
      }
    }
  }

  .files-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 1em;

    .filename {
      font-weight: 400;
      font-size: 0.75em;
    }
    .files-list-item {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
      background: main.$gray25;
      padding: 1em;
      border-radius: 0.5em;

      .file-list-item-title {
        display: flex;
        align-items: center;
        gap: 0.5em;
        margin-right: 0.5em;
      }
      > pn-progress-bar {
        margin-right: 25em;
        flex: 1;
      }

      &.files-list-item-error {
        color: main.$warning;
        background-color: main.$coral50;
      }
    }

    .files-list-item-text-error {
      color: main.$warning;
      font-size: 0.875em;
      font-weight: 300;
      margin-top: 0.25em;
    }
  }

  .pn-file-upload-title {
    color: main.$gray900;
  }
  .pn-file-upload-subtitle {
    color: main.$gray700;
    font-size: 0.75em;
  }
}
